import request from '@/utils/request';





export function listVideoTypes() {
    return request({
        url: '/video/types',
        method: 'get'
    })
}


export function listVideoProcessPage(params) {
    return request({
        url: '/page/listVideoProcessPage',
        method: 'get',
        params
    })
}


export function getSettings(data) {
    return request({
      url: `/setting/list`,
      method: 'post',
      data
    });
  }